"use strict";
import { getCarrierInvoice } from "./document_assignment/document_assignment_loader";
export const isOnAuditStep = (props) => {
  return props.load && props.load.carrier_invoices && getCarrierInvoice(props.load, props.model.selectedDocument);
};
export const isOnIndexStep = (props) => {
  return !isOnAuditStep(props);
};
export const flowStep = (props) => {
  return isOnAuditStep(props) ? "audit" : "index";
};
